import React, { Fragment } from 'react';
import Textfield from '../textfield';
import Box from '../layout/box';

function enumerateObject(obj, appendKey = '') {
	return Object.keys(obj).reduce((acc, key) => {
		const value = obj[key];
		const isArray = Array.isArray(value);
		const isObject = (typeof value === "object" ) && (value !== null);
		const isFunction = (typeof value === 'function') && (value !== null);
		if (isArray) {
			acc.push({title:`${appendKey}${key}`, value:value.toString()});
		} else if(isObject) {
			acc = acc.concat(enumerateObject(value, `${key}.`))
		} else if (!isFunction) {
			acc.push({title:`${appendKey}${key}`, value:value.toString()});
		}
		return acc;
	}, [])
}


export default function PrintObject({ value = {} }) {
	return (
		<Box>
			{enumerateObject(value).map(({title, value}, i) => (
				<Fragment key={`attr-${i}`}>
					<Textfield label={title} defaultValue={value} />
				</Fragment>
			))}
		</Box>
	);
}